var map = {
	"./decidim/avatar-multiuser.png": 18019,
	"./decidim/brands/facebook.svg": 79947,
	"./decidim/brands/google.svg": 41666,
	"./decidim/brands/twitter-x.svg": 4643,
	"./decidim/cc-badge.png": 20865,
	"./decidim/decidim-logo.svg": 84849,
	"./decidim/default-avatar.svg": 60785,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 54471,
	"./decidim/icons.svg": 49392,
	"./decidim/pattern.png": 88915,
	"./decidim/placeholder-card-g.svg": 12144,
	"./decidim/placeholder-card-l.svg": 5851,
	"./decidim/placeholder.jpg": 35698,
	"./decidim/remixicon.symbol.svg": 34408,
	"./decidim/vendor/social-share-button/douban.svg": 27483,
	"./decidim/vendor/social-share-button/email.svg": 45268,
	"./decidim/vendor/social-share-button/facebook.svg": 76656,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 9284,
	"./decidim/vendor/social-share-button/hacker_news.svg": 40504,
	"./decidim/vendor/social-share-button/linkedin.svg": 3698,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 89435,
	"./decidim/vendor/social-share-button/pinterest.svg": 97362,
	"./decidim/vendor/social-share-button/reddit.svg": 41864,
	"./decidim/vendor/social-share-button/telegram.svg": 36701,
	"./decidim/vendor/social-share-button/tumblr.svg": 73050,
	"./decidim/vendor/social-share-button/twitter.svg": 61585,
	"./decidim/vendor/social-share-button/vkontakte.svg": 33179,
	"./decidim/vendor/social-share-button/wechat.svg": 78054,
	"./decidim/vendor/social-share-button/whatsapp.svg": 46334,
	"./decidim/vendor/social-share-button/x.svg": 92396,
	"./decidim/vendor/social-share-button/xing.svg": 34508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34658;